import { createRoute, redirect } from '@tanstack/react-router'
import { AppLayout } from '@/app/layouts/AppLayout'
import { rootRoute } from './_root'

/**
 * Pathless layout route that renders Sidebar/Topbar/JobsWatcher. Every
 * authenticated route nests under this so the chrome is shared. The
 * `beforeLoad` guard sends signed-out callers to /login (preserving where
 * they tried to go in `?redirect=`).
 */
export const appShellRoute = createRoute({
  getParentRoute: () => rootRoute,
  id: '_app',
  component: AppLayout,
  beforeLoad: ({ context, location }) => {
    if (!context.auth.isSignedIn) {
      // TanStack Router uses thrown ``redirect()`` objects (not Errors) as
      // its control-flow signal — the framework catches and applies them.
      // eslint-disable-next-line @typescript-eslint/only-throw-error
      throw redirect({
        to: '/login',
        search: { redirect: location.href },
      })
    }
  },
})
